import React from 'react';
import { Col } from 'react-bootstrap';
import { FaEraser, FaPrint } from 'react-icons/fa';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineCancel } from 'react-icons/md';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { useFluxoDeCaixa } from '../../hook/useFluxoDeCaixa';
import PDFGenerator from '../../classes/PDFGenerator';

export const FormActions: React.FC = () => {
  const {
    onSearch,
    onCancel,
    onClear,
    disabledFields,
    rows,
    infoLoja,
    periodo,
  } = useFluxoDeCaixa();

  const handlePrint = () => {
    if (rows.length > 0 && infoLoja) {
      const pdfGenerator = new PDFGenerator(rows, infoLoja, periodo);
      pdfGenerator.generatePDF();
    }
  };

  return (
    <Col
      sm={12}
      md={5}
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        marginTop: '29px',
      }}
    >
      <CustomButtonNovo
        disabled={disabledFields}
        onClick={onSearch}
        label="Pesquisar"
        icon={IoIosSearch}
      />
      <CustomButtonNovo
        variant="cancel"
        disabled={!disabledFields}
        onClick={onCancel}
        label="Cancelar"
        icon={MdOutlineCancel}
      />
      <CustomButtonNovo
        variant="clear"
        disabled={disabledFields}
        onClick={onClear}
        label="Limpar"
        icon={FaEraser}
      />
      <CustomButtonNovo
        variant="default"
        disabled={rows.length <= 0}
        onClick={handlePrint}
        style={{ backgroundColor: '#666666' }}
        label="Imprimir"
        icon={FaPrint}
      />
    </Col>
  );
};
